
/* injects from baggage-loader */

'use strict';
import StarsController from './stars.controller';
import template from './stars.html';

export default {
	templateUrl: template,
	controller: StarsController,
	bindings: {
		starsCount: '=',
		lg: '='
	}
};


// WEBPACK FOOTER //
// ./src/app/components/stars/stars.component.js